import React from 'react';
import WebsiteChatSlideoutBannerNormalSrc from './WebsiteChatSlideoutBanner_normal.png';
import WebsiteChatSlideoutBannerWhiteSrc from './WebsiteChatSlideoutBanner_white.png';

export const WebsiteChatSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={WebsiteChatSlideoutBannerWhiteSrc} />
  ) : (
    <img src={WebsiteChatSlideoutBannerNormalSrc} />
  );
};
